import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "investortypes";
const initialState = {
  investortypes: [],
  loading: false,
  error: null,
};

export const fetchInvestorTypes = createAsyncThunk(
  "countries/fetchInvestorTypes",
  async () => {
    const data = await axiosApi.get(
      `${process.env.REACT_APP_BASE_URL}institutionType`
    );
    return data.data;
  }
);

const investorTypesSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchInvestorTypes.pending, (state) => {
      state.investortypes = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchInvestorTypes.fulfilled, (state, action) => {
      state.investortypes = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchInvestorTypes.rejected, (state, action) => {
      state.investortypes = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default investorTypesSlice.reducer;
